import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export const MuiSwitch = (baseTheme: Theme): Partial<Components> => ({
  MuiSwitch: {
    styleOverrides: {
      colorPrimary: {
        '&.Mui-checked': {
          color: baseTheme.palette.brand.main,
          '&~.MuiSwitch-track': {
            backgroundColor: baseTheme.palette.brand.main,
            opacity: '0.38',
          },
        },
        '&:not(.Mui-checked)': {
          color: baseTheme.palette.common.white,
          '&~.MuiSwitch-track': {
            backgroundColor: baseTheme.palette.text.primary,
            filter: 'brightness(0.38)',
          },
        },
      },
    },
  },
});
